module.exports = __webpack_public_path__ + "components/flag/static/square/ic-b84cba2a4e14287b1f544fc403552e57.svg";